import { useState } from "react";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.email || !f.subject || !f.message) { toast.error("Please fill all required fields"); return; }
    setSending(true);
    try {
      await api.post("/contact", f);
      toast.success("Message sent! We'll be in touch soon.");
      setF({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSending(false); }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-14 grid lg:grid-cols-2 gap-10">
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold">Get in touch</h1>
        <p className="text-muted-foreground mt-2">Questions about products, stores, franchising or careers? We'd love to hear from you.</p>
        <div className="mt-8 space-y-5">
          {[[Phone, "Call us", "+91 1800 123 4567"], [Mail, "Email", "hello@dksupermart.com"], [MapPin, "Head Office", "Andheri West, Mumbai, Maharashtra"]].map(([Icon, t, v], i) => (
            <div key={i} className="flex items-center gap-4">
              <span className="grid place-items-center w-12 h-12 rounded-xl bg-yellow-100 dark:bg-yellow-950 text-yellow-600"><Icon className="w-5 h-5" /></span>
              <div><p className="text-sm text-muted-foreground">{t}</p><p className="font-heading font-semibold">{v}</p></div>
            </div>
          ))}
        </div>
      </div>

      <form onSubmit={submit} className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 sm:p-8 space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Name *</Label><Input data-testid="contact-name" value={f.name} onChange={(e) => set("name", e.target.value)} /></div>
          <div><Label>Email *</Label><Input data-testid="contact-email" type="email" value={f.email} onChange={(e) => set("email", e.target.value)} /></div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Phone</Label><Input data-testid="contact-phone" value={f.phone} onChange={(e) => set("phone", e.target.value)} /></div>
          <div><Label>Subject *</Label><Input data-testid="contact-subject" value={f.subject} onChange={(e) => set("subject", e.target.value)} /></div>
        </div>
        <div><Label>Message *</Label><Textarea data-testid="contact-message" rows={5} value={f.message} onChange={(e) => set("message", e.target.value)} /></div>
        <Button type="submit" disabled={sending} data-testid="contact-submit" className="w-full bg-yellow-400 hover:bg-yellow-500 text-slate-900">
          <Send className="w-4 h-4 mr-2" /> {sending ? "Sending…" : "Send Message"}
        </Button>
      </form>
    </div>
  );
}
